
// additional suing translations, keeping separate from translations-*.ts in case those are updated in sui
export const TRANSLATIONS_SUING_EL = {
  report: {
    downloadExcelWorkbook: 'Λήψη ως Excel Workbook (.xlsx)'
  }
}
